import styles from './index.module.scss';
import noData from './images/noData.png';

const Shorts = () => {
  return (
    <div className={styles.shorts}>
      <img src={noData} />
      <div className={styles.tips}>
        Upload the nice photos or videos you&apos;ve taken recently?
      </div>
    </div>
  );
};

export default Shorts;
